document.addEventListener("DOMContentLoaded", ()=>{

  const btnCopyToClipboard      = document.getElementById("mb-copy-to-clipboard");
  const textareaCurrentPageUrl  = document.getElementById("mb-copy-to-clipboard-url"); 
  
  if(btnCopyToClipboard && textareaCurrentPageUrl ){
    btnCopyToClipboard.addEventListener("click", (e)=> copyToClipboard(textareaCurrentPageUrl));
  }
  }
);

function copyToClipboard(textarea) {
  const textToCopy = textarea.value;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          showTooltip();
        })
        .catch((error) => {
          fallbackCopyToClipboard(textarea);
        });
    } else {
      fallbackCopyToClipboard(textarea);
    }
  }

  function fallbackCopyToClipboard(textarea) {
    textarea.select();
    document.execCommand('copy');
    showTooltip();
  }

  function showTooltip() {
    const tooltip = document.getElementById('mb-copy-to-clipboard-tooltip');
    tooltip.classList.add("active");

    setTimeout(() => {
      tooltip.classList.remove("active");
    }, 3000);
  }